import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import { CSSProperties } from 'react';

export type ServiceValue = 'normal' | 'rush';

interface ServiceBadgeProps {
  /** Raw or display service value — matching is case-insensitive. */
  service: string | null | undefined;
}

const chipStyle: CSSProperties = {
  display: 'inline-flex',
  flexDirection: 'row',
  gap: '0.1875rem',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.1875rem 0.625rem',
  borderRadius: '1.25rem',
  border: 'none',
  background: '#ffe8e7',
  verticalAlign: 'middle',
};

const RUSH_COLOR = '#5E0A05';

/**
 * Renders the job service method.
 *
 * "Rush" is rendered as a highlighted chip so it is visually striking next to
 * the plain-text "Normal" value (COS-25824). Styling intentionally mirrors
 * `OnHoldReasonBadge` so both chips read as the same design family.
 */
const ServiceBadge = ({ service }: ServiceBadgeProps) => {
  if (!service) return null;

  const isRush = service.toLowerCase() === 'rush';

  if (!isRush) {
    return (
      <Typography component="span" sx={{ fontSize: '0.875rem' }}>
        Normal
      </Typography>
    );
  }

  return (
    <span style={chipStyle}>
      <AccessTimeIcon sx={{ fontSize: '0.875rem', color: RUSH_COLOR }} />
      <Typography component="span" sx={{ fontSize: '0.875rem', color: RUSH_COLOR }}>
        Rush
      </Typography>
    </span>
  );
};

export default ServiceBadge;
